import {mainStorage} from "@/composables/tools/main-storage.tools.js";
import {getToken} from "@/composables/auth";
import {changeLoadApp, changeShow} from "@/composables/ModuleCommunication";

/**
 * Инициализирует интерсепторы для экземпляра Axios, добавляя токен авторизации к каждому запросу
 * и обрабатывая ошибки ответов. При >5 неуспешных попыток авторизации - прерывает запросы.
 *
 * @param {Object} axios - Экземпляр Axios, к которому будут добавлены интерсепторы.
 * @param {Object} LKStore - Экземпляр хранилища (LKStore), который используется для управления состоянием
 *                           и перенаправления пользователя на страницу логина в случае ошибок авторизации.
 */
export function axiosInit(axios, LKStore) {
    const MAX_RETRIES = 5;

    axios.interceptors.request.use(async (config) => {
        // Счетчик попыток запроса
        if (config._retryCount == null) {
            config._retryCount = 0;
        }

        if (!config.url.includes("/login")) {
            const token = mainStorage.getItem("access_token");
            config.headers.Authorization = "Bearer " + token;
        }
        return config;
    });
    axios.interceptors.response.use((response) => {
        response.config._retryCount = 0;
        return response;
    }, async (error) => {

        const config = error.config;
        const status = error?.response?.status;

        changeLoadApp(true);
        changeShow(true);
        if (status === 401 && window.location.pathname !== "/login") {

            // ====== Счетчик попыток авторизации
            if (config._retryCount >= MAX_RETRIES) {
                // Редиректим на логин и блокируем дальнейшие попытки для этого запроса
                LKStore.goLogin();
                changeLoadApp(false);
                changeShow(false);
                return Promise.reject(new Error(`Превышено ${MAX_RETRIES} попыток авторизации`));
            }
            config._retryCount += 1;
            // Счетчик попыток авторизации =====

            const refreshToken = await getToken();

            if (refreshToken === false) {
                LKStore.goLogin();
                changeLoadApp(false);
                changeShow(false);
            } else {
                const originalRequests = error.config;
                delete originalRequests.headers["Authorization"];
                return axios.request(originalRequests);
            }
        } else if (status >= 400 && status < 600 ) {
            throw error;
        }
        else {
            console.log("Возникла ошибка при загрузке данных:", error);
        }
        return error;
    });
}
